<div [ngClass]="this.menuService.menuOptions['import'] ? 'active' : ''" class="import-menu">
  <div>
    <h1>Import</h1>
    <ul>
      <app-menu-option
        [action]="this.openImportLayer.bind(this)"
        [fileExplorer]="true"
        [labelOnMenu]="'Layer'"
        [label]="'Import Layer'"
        [fileFormats]="this.layerFormats">
      </app-menu-option>

        <app-menu-option *editable
                         [action]="this.importService.showMesssageModal.bind(importService, 'NavAids', this.navaidsFormats)"
                         [labelOnMenu]="'NavAids'"
                         [label]="'Import Navaids'">
        </app-menu-option>
        <app-menu-option *editable
                         [action]="this.importService.showMesssageModal.bind(importService, 'Coordinate Points', this.coordPointsFormats)"
                         [labelOnMenu]="'Coordinate Points'"
                         [label]="'Import Coordinate Points'">
        </app-menu-option>
        <app-menu-option
          [action]="this.importService.showMesssageModal.bind(importService, 'Receivers', this.gritFormats)"
          [labelOnMenu]="'Receivers'"
          [label]="'Import Receiver'">
        </app-menu-option>

        <app-menu-option *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser)"

          [action]="this.importService.showMesssageModal.bind(importService, 'RFI-Transmitters', this.gritFormats)"
          [labelOnMenu]="'RFI-Transmitters'"
          [label]="'Import RFI-Transmitters'">
        </app-menu-option>
        <app-menu-option *ngIf="gritInterferenceTestService.allowedStates(InterferenceTestModelStates.Draft, InterferenceTestModelStates.Approval)"
                         [action]="this.importService.showMesssageModal.bind(importService, 'Map RFI-Transmitters', this.gritFormats)"
                         [labelOnMenu]="'Map RFI-Transmitters'"
                         [label]="'Import Map RFI-Transmitters'">
        </app-menu-option>

<!--      <ng-template [access]="0">
        <app-menu-option
          [action]="this.importService.showMesssageModal.bind(importService, 'Procedures', this.proceduresFormats)"
          [labelOnMenu]="'Procedures'"
          [label]="'Import Procedures'">
        </app-menu-option>
        <app-menu-option
          [action]="this.importService.showMesssageModal.bind(importService, 'Flight Inspections', this.inspectionService.fileFormats)"
          [labelOnMenu]="'Flight Inspections'"
          [label]="'Import Flight Inspections'">
        </app-menu-option>
        <app-menu-option
          [action]="this.importService.showMesssageModal.bind(importService, 'Aerodromes', this.aerodromesFormats)"
          [labelOnMenu]="'Aerodromes'"
          [label]="'Import Aerodromes'">
        </app-menu-option>
        <app-menu-option
          [action]="this.importService.showMesssageModal.bind(importService, 'Route Segments', this.routeSegmentsFormats)"
          [labelOnMenu]="'Route Segments'"
          [label]="'Import Route Segments'">
        </app-menu-option>
        <app-menu-option
          [action]="this.importService.showMesssageModal.bind(importService, 'Vertex', this.vertexFormats)"
          [labelOnMenu]="'Vertex'"
          [label]="'Import Vertex'">
        </app-menu-option>
      </ng-template>
      <ng-template [access]="0">
        <app-menu-option
          [action]="this.openSAAMTraficdensityImport.bind(this)"
          [fileExplorer]="true"
          [labelOnMenu]="'SAAM Layer'"
          [label]="'Import SAAM Layer'">
        </app-menu-option>
        <app-menu-option
          [action]="this.importService.showMesssageModal.bind(importService, 'RVT/KMZ', this.rvtKmzFormats)"
          [labelOnMenu]="'Trajectories'"
          [label]="'Import Trajectories'">
        </app-menu-option>
        <app-menu-option
          [action]="this.uploadAirSpaceBoundaryXML.bind(this)"
          [fileExplorer]="true"
          [labelOnMenu]="'AirSpace Boundaries'"
          [label]="'Import AirSpace Boundaries'">
        </app-menu-option>
        <app-menu-option
          [action]="this.openObstacleDataImport.bind(this)"
          [labelOnMenu]="'Obstacle Data'"
          [label]="'Import Obstacle Data'">
        </app-menu-option>
      </ng-template>-->
    </ul>
  </div>
</div>

